import { Flex } from '@/ui/Flex/Flex';
import { FormattedMessage, useIntl } from 'react-intl';
import { Tooltip } from '@/ui/Tooltip/Tooltip';
import React from 'react';
import { StyledCircle, StyledSubText } from '../styles';

export enum LinkedPlayerState {
  ONLINE = 'ONLINE',
  PARTIAL = 'PARTIAL',
  OFFLINE = 'OFFLINE',
}

type DisplayStatusProps = {
  isElectron: boolean;
  isReady: boolean;
  totalPlayers: number;
  totalOnline: number;
  productType: string;
};

export const DisplayStatus = ({
  isElectron,
  isReady,
  totalPlayers,
  totalOnline,
  productType,
}: DisplayStatusProps) => {
  const intl = useIntl();

  let statusLinkedPlayer: LinkedPlayerState = LinkedPlayerState.OFFLINE;
  if (totalOnline > 0) {
    statusLinkedPlayer = LinkedPlayerState.PARTIAL;
  }
  if (totalOnline >= totalPlayers) {
    statusLinkedPlayer = LinkedPlayerState.ONLINE;
  }

  return isElectron ? (
    <Flex align="center" gap={24}>
      <StyledSubText>
        <FormattedMessage defaultMessage="Ready for Offline" id="dnuzqh" />:
      </StyledSubText>
      <Tooltip
        title={
          isReady
            ? intl.formatMessage({
                defaultMessage: 'Ready for offline use',
                id: 'Wd99G9',
              })
            : intl.formatMessage({
                defaultMessage:
                  'Not ready for offline use, please start the player in online mode to cache assets',
                id: 'ukz1Vq',
              })
        }
        testId="display-status-tooltip-electron"
      >
        <StyledCircle
          status={
            isReady ? LinkedPlayerState.ONLINE : LinkedPlayerState.OFFLINE
          }
        />
      </Tooltip>
    </Flex>
  ) : (
    productType !== 'TrihowPad' && totalPlayers > 0 && (
      <Flex align="center" gap={24}>
        <StyledSubText data-testid="player-status">
          <FormattedMessage defaultMessage="Player status" id="+SqK21" />:
        </StyledSubText>
        <Tooltip
          title={`${totalOnline}/${totalPlayers} ${intl.formatMessage({
            defaultMessage: 'player online',
            id: 'UGjCfd',
          })}`}
          testId="display-status-tooltip-web"
        >
          <StyledCircle status={statusLinkedPlayer} />
        </Tooltip>
      </Flex>
    )
  );
};
